(() => {
  'use strict';

  const popup = document.getElementById('whatsappPopup');
  if (!popup || popup.dataset.initialized) return;
  popup.dataset.initialized = 'true';

  const configuredDelay = Number(popup.dataset.delay);
  const delay = Number.isFinite(configuredDelay) && configuredDelay >= 0 ? configuredDelay : 10000;
  const autoOpen = popup.dataset.autoOpen !== 'false';
  const rememberClose = popup.dataset.rememberClose !== 'false';
  const frequency = popup.dataset.frequency || 'page';
  const editorPreview = Boolean(window.Shopify?.designMode && popup.dataset.editorPreview === 'true');
  const widget = popup.closest('#wb-whatsapp-widget');
  const opener = document.querySelector('[data-whatsapp-open]');
  const mobile = window.matchMedia('(max-width: 1023px)');
  const sessionKey = 'wb:whatsapp:prompt-shown';
  const dayKey = 'wb:whatsapp:prompt-last-shown';
  let timer;
  let shown = false;

  function stored(storage, key) {
    try { return window[storage].getItem(key); } catch (_) { return null; }
  }

  function remember(storage, key, value = 'true') {
    if (editorPreview) return;
    try { window[storage].setItem(key, value); } catch (_) { /* Storage can be unavailable in private browsing. */ }
  }

  function rememberShown() {
    if (frequency === 'day') remember('localStorage', dayKey, String(Date.now()));
    else if (frequency !== 'page') remember('sessionStorage', sessionKey);
  }

  function suppressed() {
    if (editorPreview) return false;
    if (rememberClose && stored('localStorage', 'whatsappPopupClosed')) return true;
    if (frequency === 'page') return false;
    if (frequency === 'day') {
      const lastShown = Number(stored('localStorage', dayKey));
      return lastShown > 0 && Date.now() - lastShown < 86400000;
    }
    return Boolean(stored('sessionStorage', sessionKey));
  }

  function deviceEnabled() {
    return !widget || widget.dataset[mobile.matches ? 'mobile' : 'desktop'] !== 'false';
  }

  function hide() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    opener?.setAttribute('aria-expanded', 'false');
  }

  function show() {
    shown = true;
    rememberShown();
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    opener?.setAttribute('aria-expanded', 'true');
  }

  function stop() {
    clearTimeout(timer);
    timer = null;
    document.removeEventListener('visibilitychange', schedule);
    window.removeEventListener('pageshow', schedule);
    mobile.removeEventListener('change', schedule);
  }

  function dismiss(restoreFocus = false) {
    shown = true;
    rememberShown();
    hide();
    stop();
    if (restoreFocus) opener?.focus({ preventScroll: true });
  }

  function schedule() {
    if (editorPreview) {
      popup.classList.toggle('is-visible', deviceEnabled());
      popup.setAttribute('aria-hidden', String(!deviceEnabled()));
      opener?.setAttribute('aria-expanded', String(deviceEnabled()));
      return;
    }
    if (shown) return;
    if (!autoOpen || suppressed()) {
      stop();
      return;
    }
    if (!deviceEnabled() || document.hidden) {
      clearTimeout(timer);
      timer = null;
      return;
    }
    if (timer) return;
    timer = setTimeout(() => {
      timer = null;
      if (!deviceEnabled() || document.hidden) return;
      if (suppressed()) return;
      show();
    }, delay);
  }

  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pageshow', schedule);
  mobile.addEventListener('change', schedule);
  opener?.addEventListener('click', () => {
    if (!deviceEnabled()) return;
    if (popup.classList.contains('is-visible')) {
      dismiss(true);
      return;
    }
    // Explicit clicks bypass automatic timing and remembered dismissals.
    stop();
    show();
    popup.querySelector('[data-whatsapp-close]').focus({ preventScroll: true });
  });
  popup.querySelector('[data-whatsapp-close]').addEventListener('click', () => {
    if (rememberClose) remember('localStorage', 'whatsappPopupClosed');
    dismiss(true);
  });
  popup.querySelectorAll('[data-whatsapp-link]').forEach(link => link.addEventListener('click', () => {
    try { localStorage.removeItem('whatsappPopupClosed'); } catch (_) { /* Storage can be unavailable. */ }
    dismiss();
  }));
  popup.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      dismiss(true);
    }
  });
  schedule();
})();
